import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { observable } from "mobx";
import { Tab, Tabs } from "@blueprintjs/core";
import HistoricoNotasPage from "./Manifestacoes";
import CalculoManifestacoes from "./CalculoManifestacoes";
import TarefasManifestacoes from "./TarefasManifestacoes";
import { ManifestacoesStore } from "../../stores/manifestacoes/ManifestacoesStore";

@observer
export default class ManifestacoesPage extends React.Component<{}, {}> {

  obs = observable({
    selectedTab: "manifestacoes" as string
  })

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    AppStore.setTitle("Manifestações");
    this.handldeChargeTab(this.obs.selectedTab);
  }

  handldeChargeTab(tabId: string) {
    if (this.obs.selectedTab === "tarefas" && tabId !== "tarefas") {
      ManifestacoesStore.obs.tasks_manifestacoes_nfse = [];
      ManifestacoesStore.obs.length_tasks_manifestacoes_nfse = 0;
    }

    this.obs.selectedTab = tabId;

    if (tabId === "manifestacoes") {
      ManifestacoesStore.handleConsultaTodas(1, 15);
    }

    if (tabId === "calculos") {
      ManifestacoesStore.obs.calcularItems = [];
      ManifestacoesStore.handldeItensProcessando();
    }

    if (tabId === "tarefas") {
      ManifestacoesStore.handleConsultaTasksManifestacoesDownload(1, 15);
    }
  }

  render() {
    return (
      <Tabs
        id="tabs"
        className={"tabsCalculos"}
        selectedTabId={this.obs.selectedTab}
        onChange={(tabId) => this.handldeChargeTab(tabId as string)}
        renderActiveTabPanelOnly={true}
        data-tut="resumo"
      >
        <Tab
          id="manifestacoes"
          title="Manifestações"
          panel={
            <HistoricoNotasPage />
          }
        />

        <Tab
          id="calculos"
          title="Cálculo Manifestações"
          panel={
            <CalculoManifestacoes />
          }
        />

        <Tab
          id="tarefas"
          title="Download Manifestações"
          panel={
            <TarefasManifestacoes />
          }
        />
      </Tabs>
    )
  }
}